import React from "react";

class VersionChecker extends React.Component {
  componentDidMount() {
    this.checkForNewVersion();
    this.interval = setInterval(this.checkForNewVersion, 5 * 1000);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      this.checkForNewVersion();
    }
  };

  checkForNewVersion = async () => {
    try {
      const response = await fetch(`/version.json?ts=${Date.now()}`, {
        cache: "no-store",
      });
      const data = await response.json();
      
      // Support both buildVersionCp and buildVersionCp_CVS for backward compatibility
      const buildVersionCp = data.buildVersionCp || data.buildVersionCp_CVS;
      
      if (!buildVersionCp) {
        console.warn("No valid version found in version.json");
        return;
      }
      
      const currentVersion = localStorage.getItem("buildVersionCp");

      if (currentVersion && currentVersion !== buildVersionCp) {
        localStorage.setItem("buildVersionCp", buildVersionCp);

        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        }

        // Force a full reload immediately
        window.location.reload();
      } else if (!currentVersion) {
        localStorage.setItem("buildVersionCp", buildVersionCp);
      }
    } catch (error) {
      console.error("Version check failed:", error);
    }
  };

  render() {
    return null; // invisible component
  }
}

export default VersionChecker;
